import { defineComponent as _defineComponent } from 'vue'
import TiptapEditor from '@/components/form/editor/tiptap-editor.vue'
import { computed, nextTick } from 'vue'

interface Props {
  value: string
  placeholder: string
  errorMessages: string[]
  validate: () => void
}

interface Emits {
  (e: 'input', value: string): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'tm-rich-text-editor',
  props: {
    value: null,
    placeholder: null,
    errorMessages: null,
    validate: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: string
  placeholder: string
  errorMessages: string[]
  validate: () => void
}





const formValue = computed({
    get () {
        return props.value
    },
    set (newValue) {
        emit('input', newValue)
    }
})

const handleValidate = async () => {
    // ensure field is updated in parent component before validation
    await nextTick()

    props.validate()
}

const handleKeyUp = (event: KeyboardEvent) => {
    event.key !== 'Tab' && props.validate()
}

function inTestMode (): boolean {
    // @ts-ignore
    return typeof window.richTextEditorTestMode !== 'undefined'
}

return { __sfc: true,props, emit, formValue, handleValidate, handleKeyUp, inTestMode, TiptapEditor }
}

})